import Container from '@/components/base/Container'
import Form, { FromProps } from '@/components/base/Form'
import Grid from '@/components/base/Grid'
import Motion from '@/components/base/Motion'
import Typography, { TypographyProps } from '@/components/base/Typography'

import { contactFormRevealAnimation } from './animations'
import { Section } from '@/types'

type ContactFormProps = Section &
  Partial<{
    title: string
    title_variant: TypographyProps['variant']
    title_component: TypographyProps['component']
    overline: string
    paragraph: string
    form: FromProps['fields']
    form_id: string
  }>

const ContactForm = ({
  title,
  title_variant,
  title_component,
  overline,
  paragraph,
  form,
  form_id,
  ...props
}: ContactFormProps) => {
  return (
    <Motion animation={contactFormRevealAnimation}>
      {(motionRef) => (
        <section ref={motionRef} {...props}>
          <Container>
            <Grid className="gap-y-lg">
              {overline || title || paragraph ? (
                <div className="col-span-2 md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3">
                  <div className="grid gap-y-lg">
                    <div className="grid gap-y-lg">
                      {overline ? (
                        <Typography
                          variant="overline"
                          paragraph
                          className="text-white"
                          data-motion-overline
                        >
                          {overline}
                        </Typography>
                      ) : null}

                      {title ? (
                        <Typography
                          variant={title_variant}
                          component={title_component}
                          className="uppercase text-white [&_em]:text-blue-soft"
                          data-motion-title
                        >
                          {title}
                        </Typography>
                      ) : null}

                      {paragraph ? (
                        <Typography
                          variant="body"
                          paragraph
                          className="text-neutral-80"
                          data-motion-paragraph
                        >
                          {paragraph}
                        </Typography>
                      ) : null}
                    </div>
                  </div>
                </div>
              ) : null}
              <div className="col-span-2 md:col-span-4 md:col-start-2 lg:col-span-8 lg:col-start-3">
                <Form fields={form} form_id={form_id} />
              </div>
            </Grid>
          </Container>
        </section>
      )}
    </Motion>
  )
}

export default ContactForm
